export default __webpack_public_path__ + "static/media/boost-app.92ce9fb0.svg";